import React from "react";
import { BaseEditorComponent } from "@handsontable/react";
import PublishIcon from "@material-ui/icons/Publish";
import { tesaBlue } from "../../../../../../styles/colors";
import StyledTooltip from "../../../../../../components/Wrapper/StyledTooltip";

interface FileUploadRendererComponentProps {
  TD?: HTMLTableDataCellElement;
}
export class FileUploadRendererComponent extends BaseEditorComponent<FileUploadRendererComponentProps> {
  render(): React.ReactElement | undefined {
    const { TD } = this.props as FileUploadRendererComponentProps;
    if (TD) {
      TD.style.textAlign = "center";
    }
    return (
      <StyledTooltip title="Add Picture or Document on Repetition">
        <PublishIcon
          style={{
            cursor: "pointer",
            color: tesaBlue,
            transform: "translateY(3px)",
          }}
        />
      </StyledTooltip>
    );
  }
}
export default FileUploadRendererComponent;
